// Landing page
export const LANDING = '/landing';
export const FOR_WHOM = `${LANDING}/for-whom`;
export const FEATURES = `${LANDING}/features`;
export const EXAMPLE = `${LANDING}/example`;

// Auth pages links
export const AUTH = '/auth';
export const LOGIN = `${AUTH}/login`;
export const SIGN_UP = `${AUTH}/sign-up`;
export const SET_NEW_PASSWORD = `${AUTH}/set-new-password`;
export const COMPLETE_REGISTRATION = `${AUTH}/complete-registration`;
export const COMPLETE_PERSONAL_DATA = `${AUTH}/complete-personal-data`;
export const VERIFY_EMAIL = `${AUTH}/verify-email`;
export const VERIFY_PHONE_NUMBER = `${AUTH}/verify-phone-number`;

// Public pages (no auth required)
export const PUBLIC = '/public';
export const PUBLIC_ANALYSIS = `${PUBLIC}/analyses/$analysisId`;

// Common link
export const HOME = '/';

// Application pages links
export const APP = '/app';

// Analyses
export const ANALYSES = `${APP}/analyses`;
export const CREATE_NEW_ANALYSIS = `${ANALYSES}/new`;
export const ANALYSIS_DETAIL = `${ANALYSES}/$analysisId`;
export const LAST_ANALYSIS = `${ANALYSES}/last`;
